import { useState, useEffect } from 'react';

const LAUNCH_DATE = '2026-03-27';

export function LaunchBanner() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Only show on launch day
    const today = new Date().toISOString().split('T')[0];
    if (today !== LAUNCH_DATE) return;

    // Don't show if already dismissed this session
    if (sessionStorage.getItem('launch-banner-dismissed')) return;

    setVisible(true);
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('launch-banner-dismissed', '1');
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <>
      {/* Confetti particles */}
      <div className="confetti-container" aria-hidden="true">
        {Array.from({ length: 50 }).map((_, i) => (
          <div
            key={i}
            className="confetti-piece"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 3}s`,
              backgroundColor: ['#FF8C42', '#FF6B35', '#FFD60A', '#34C759', '#007AFF', '#AF52DE', '#FF2D55', '#06B6D4'][Math.floor(Math.random() * 8)],
              width: `${4 + Math.random() * 6}px`,
              height: `${4 + Math.random() * 6}px`,
              borderRadius: Math.random() > 0.5 ? '50%' : '2px',
              transform: `rotate(${Math.random() * 360}deg)`,
            }}
          />
        ))}
      </div>

      {/* Banner */}
      <div
        className={dismissed ? 'launch-banner-exit' : 'launch-banner-enter'}
        style={{
          position: 'relative',
          zIndex: 50,
          padding: '14px 24px',
          background: 'linear-gradient(135deg, #FF8C42 0%, #FF6B35 50%, #FF5722 100%)',
          color: '#fff',
          textAlign: 'center',
          fontSize: '15px',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          flexWrap: 'wrap',
          overflow: 'hidden',
        }}
      >
        {/* Shimmer overlay */}
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)',
          backgroundSize: '200% 100%',
          animation: 'shimmer 2s linear infinite',
          pointerEvents: 'none',
        }} />

        <span style={{ fontSize: '24px', animation: 'rocketLaunch 2s ease-in-out infinite' }}>🚀</span>
        <span style={{ position: 'relative' }}>
          <strong>We just launched!</strong> Welcome to Pastewala — free paste sharing for everyone
        </span>
        <span style={{ fontSize: '20px', animation: 'float 2s ease-in-out infinite 0.5s' }}>🎉</span>

        <button
          onClick={handleDismiss}
          style={{
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            color: '#fff',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
          }}
        >
          ✕
        </button>
      </div>

      <style>{`
        @keyframes rocketLaunch {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          25% { transform: translateY(-6px) rotate(-5deg); }
          50% { transform: translateY(-10px) rotate(0deg); }
          75% { transform: translateY(-4px) rotate(5deg); }
        }

        .launch-banner-enter {
          animation: fadeInDown 0.5s ease-out;
        }

        .launch-banner-exit {
          animation: slideUpOut 0.4s ease-in forwards;
        }

        @keyframes slideUpOut {
          to { transform: translateY(-100%); opacity: 0; margin-bottom: -48px; }
        }

        /* Confetti */
        .confetti-container {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 100vh;
          pointer-events: none;
          z-index: 9999;
          overflow: hidden;
          animation: fadeOut 5s ease forwards 4s;
        }

        @keyframes fadeOut {
          to { opacity: 0; }
        }

        .confetti-piece {
          position: absolute;
          top: -10px;
          animation: confettiFall linear forwards;
          opacity: 0.9;
        }

        @keyframes confettiFall {
          0% {
            transform: translateY(0) rotate(0deg) scale(1);
            opacity: 1;
          }
          25% {
            transform: translateY(25vh) rotate(180deg) translateX(30px) scale(0.9);
            opacity: 1;
          }
          50% {
            transform: translateY(50vh) rotate(360deg) translateX(-20px) scale(0.8);
            opacity: 0.8;
          }
          75% {
            transform: translateY(75vh) rotate(540deg) translateX(15px) scale(0.6);
            opacity: 0.5;
          }
          100% {
            transform: translateY(105vh) rotate(720deg) translateX(-10px) scale(0.3);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
}
